import { resolveAdminToken, resolveApiBaseUrl } from './utils'

type ApiRequestOptions = RequestInit & { auth?: boolean }

export async function requestApi<T>(path: string, options: ApiRequestOptions = {}) {
  const apiBaseUrl = resolveApiBaseUrl()
  const token = resolveAdminToken()
  const headers = new Headers(options.headers)

  if (options.auth !== false && token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  if (options.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }

  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers
  })

  const payload = await response.json().catch(() => null)

  if (!response.ok) {
    const message = payload?.detail || payload?.message || '请求失败'
    throw new Error(message)
  }

  return payload as T
}
